<template>
  <div class="book-detail">
    <!-- 左边 -->
    <div class="detail-left">
      <div class="left-background">
        <!-- <img width="119px" height="159px;" src="@/assets/image 87.png" alt="" /> -->
        <myXgplayer
          v-if="props.info.video_url"
          :width="341"
          :height="341"
          :url="props.info.video_url"
          :poster="props.info.img_type ? img_type : ''"
        ></myXgplayer>
        
        <img
          v-else
          :class="props.info.img_type === 2 ? 'bigwidth5' : ''"
          width="200px"
          v-complete:src="props.info.img_url"
        />
      </div>
    </div>
    <!-- 右边 -->
    <div class="detail-right">
      <p class="right-title">
        {{ props.info.title }}
      </p>
      <div class="right-dashedBox">
        <p>
          学科：
          <!-- <span>{{ byIdGetText(props.info.subject_id, "book_subject") }}</span> -->
          <span
            v-for="(item, index) in props.info.subject_list"
            :key="index"
            style="margin-right: 5px"
            >{{ item.name }}</span
          >
        </p>
        <p>
          上市时间：
          <span>{{
            props.info.publishing_time === undefined
              ? props.info.versions_year - 1 + "-01"
              : props.info.publishing_time.slice(0, 7)
          }}</span>
        </p>
        <p>
          适用：
          <span
            >{{ byIdGetText(props.info.grade_id, "book_grade") }}  
            {{
              byIdGetText(props.info.version_years, "book_version_years")
            }}</span
          >
        </p>
        <p
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
        >
          地区：
          <span v-for="(item, index) in props.info.address" :key="index" style="margin-right: 6px">
            {{ item.name }}
          </span>
        </p>
      </div>
      <div class="right-buttonBox">
        <el-button round @click="buyBtnClick(1)">电子样书</el-button>
        <el-button round @click="buyBtnClick(2)">天猫购买</el-button>
        <el-button round @click="buyBtnClick(3)">京东购买</el-button>
        <el-button round @click="buyBtnClick(4)">下线书店</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from "element-plus";
// import { reactive } from "@vue/reactivity";
import { reactive, includes } from "@vue/reactivity";
import { useRouter } from "vue-router";

import { completeUrl } from "@/utils/utils.js";
import myXgplayer from "@/components/myXgplayer/index.vue";

let router = useRouter();

const props = defineProps({
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const mydata = reactive({
  book_version_years:
    JSON.parse(localStorage.getItem("book_version_years")) ?? [],
  book_grade: JSON.parse(localStorage.getItem("book_grade")) ?? [],
  book_subject: JSON.parse(localStorage.getItem("book_subject")) ?? [],
});

// console.log("---------");
// console.log(mydata);
// console.log("---------");

// 通过ID得到对应文字
function byIdGetText(id, key) {
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

function buyBtnClick(type) {
  // 1 电子样书 e_book
  // 2 京东购买 buy_url_jd
  // 3 天猫购买 buy_url
  // 4 线下书店
  if (type === 1) {
    // window.open(props.info.e_book);
    // console.log(props.info.e_book,"电子样书")

     
    if (props.info.e_book === null) {
       // 提示弹窗
      ElMessage({
        message: " 暂无链接",
        type: "warning",
      });
      return;
    }else{
      window.open(props.info.e_book);
      return;
    }
   
    // if (props.info.e_book === null) {
    //   return;
    // }

    // 如果是完整地址，那么先分割成数组再进行跳转；如果不是完整地址，那么直接跳转
    // if (
    //   props.info.e_book.includes("http://") ||
    //   props.info.e_book.includes("https://") ||
    //   props.info.e_book.includes("#")
    // ) {
    //   router.push({ path: props.info.e_book.split("#")[1] });
    // } else {
    //   router.push({ path: props.info.e_book });
    // }

    // return;
  }
  if (type === 2) {
    if (props.info.e_book === null) {
       // 提示弹窗
      ElMessage({
        message: " 暂无链接",
        type: "warning",
      });
      return;
    }else{
      window.open(props.info.buy_url_jd);
      return;
    }
   
  }
  if (type === 3) {
    if (props.info.e_book === null) {
       // 提示弹窗
      ElMessage({
        message: " 暂无链接",
        type: "warning",
      });
      return;
    }else{
       window.open(props.info.buy_url);
       return;
    }
   
  }
  // 后端还没有这个字段呢
  if (type === 4) {
    router.push({
      path:"/layout/list/offlineAgent"
    })
  }
}
</script>

<style scoped lang="scss">
.book-detail {
  width: 343px;
  // height: 220px;
  //border: 1px solid #2bb90f;
  // display: flex;
  // justify-content: space-between;
  padding-top: 16px;
  //////左边
  .detail-left {
    width: 343px;
    height: 343px;
    // padding: 14px;
    border: 1px solid #cccccc;
    border-radius: 8px;
    background-color: #ffffff;

    .left-background {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      background-color: #f2f2f2;
      display: flex;
      justify-content: center;
      align-items: center;
      // border:1px solid red;
      img {
        width: 200px;
        display: block;
        // width: 119px;
        // height: 168px;
        // width: 119px;
        // height: 159px;
        // margin: 0 auto;
        // margin-top: 12px;
        // margin-left: 36px;
        // border: 1px solid #2bb90f;
      }
    }
  }
  //////右边
  .detail-right {
    width: 343px;
    // height: 208px;
    margin-top: 24px;
    margin-bottom: 10px;
    // border: 1px solid #1a0fb9;
    ///////右边title
    .right-title {
      font-size: 16px;
      font-weight: 700;
      color: #333333;
      margin-bottom: 16px;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
    }
    //////右边虚线盒子
    .right-dashedBox {
      width: 100%;
      // height: 108px;
      border: 1px dashed #009de0;
      border-radius: 8px;
      background-color: #f8faff;
      margin-bottom: 16px;
      padding: 10px;
      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #333333;
      }
    }
    //////右边按钮盒子
    .right-buttonBox {
      width: 100%;
      height: 44px;
      //   border: 1px dashed #009de0;
      display: flex;
      justify-content: space-between;

      :deep(.el-button.is-round) {
        width: 79px;
        height: 29px;
      }
      :deep(.el-button + .el-button) {
        margin-left: 0px;
      }
    }
  }
}
</style>
